import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, JsonpModule, Jsonp, Response } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

// App Modules
import { AppRoutingModule} from './app-routing.module';
import { AppComponent } from './app.component';
import { SuggestDiagnosisService } from './services/suggest-diagnosis.service';
import { SymptomDetailsService } from './services/symptom-details-service';

import { SymptomDisplayDirective } from './diagnosis-results/diagnosis-filter.directive';
import { DiagnosisResultsResolver } from './resolvers/diagnosis-results-resolver';

import { SuggestDiagnosisComponent } from './suggest-diagnosis/suggest-diagnosis.component';
import { DiagnosisResultsComponent } from './diagnosis-results/diagnosis-results.component';
import { SymptomDetailsComponent } from './symptom-details/symptom-details.component';
import { ArticleDetailsComponent } from './article-details/article-details.component';
// import { WhereToGoToolComponent } from './where-to-go-tool/where-to-go-tool.component';
import { SafePipe } from './common/safe-pipe';

// 3rd Party Modules
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  declarations: [
    AppComponent,
    SuggestDiagnosisComponent,
    DiagnosisResultsComponent,
    SymptomDisplayDirective,
    SymptomDetailsComponent,
    ArticleDetailsComponent,
    // WhereToGoToolComponent,
    SafePipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    JsonpModule,
    BrowserAnimationsModule,
    NgbTypeaheadModule.forRoot(),
    NgbPopoverModule.forRoot()
  ],
  providers: [
    SuggestDiagnosisService,
    DiagnosisResultsResolver,
    SymptomDetailsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts